import styled, {css} from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {Colors} from "@brg/ui";


export const ShareModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background: #FEFEFE;
  width: 564px;
  //height: 310px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 24px;
  row-gap: 24px;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    row-gap: 16px;
    padding: 32px 0px 24px;
  }
`

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalHeader = styled.div<{isVotingTitle?: boolean}>`
  color: #151514;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 30}px;
  line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 40}px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 17 : 30}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 22 : 40}px;
    margin: 0 10px;
  }
`

export const ShareModalSend = styled.div<{isDisabled?: boolean}>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
  // color: ${Colors.galBlack10};
  column-gap: 0px;
  display: flex;
  align-items: center;
  //cursor: pointer;
  width: fit-content;
  white-space: nowrap;
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
  }

  &:hover {
    .send-word {
      color: #151514;
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 44px;
  width: 341px;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    width: 90%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(RectangularButtonFilled)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  padding: 12px 48px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  height: 46px!important;
  letter-spacing: -0.02em;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px;
    height: 32px!important;
  }
`

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};

  cursor: pointer;

  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
  }

  &:hover {
    color: #151514;

    svg path {
      fill: #151514;
    }
  }
`import styled, {css} from "styled-components";
import {RectangularButtonFilled} from "../../components/buttons";
import {LayoutConst} from "../../../core";
import {Colors} from "@brg/ui";


export const ShareModalBody = styled.div`
  display: flex;
  flex-direction: column;
  background: #FEFEFE;
  width: 564px;
  //height: 310px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 24px;
  row-gap: 24px;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    border-radius: 8px 8px 0 0;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);
    row-gap: 16px;
    padding: 32px 0px 24px;
  }
`

export const CloseModalIconWrapper = styled.div`
    position: absolute;
    right: 0;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    right: 10px;
  }

  &:hover {
    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalHeader = styled.div<{isVotingTitle?: boolean}>`
  color: #151514;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({isVotingTitle}) => isVotingTitle ? 22 : 30}px;
  line-height: ${({isVotingTitle}) => isVotingTitle ? 28 : 40}px;
  letter-spacing: -0.02em;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({isVotingTitle}) => isVotingTitle ? 17 : 30}px;
    line-height: ${({isVotingTitle}) => isVotingTitle ? 22 : 40}px;
    margin: 0 10px;
  }
`

export const ShareModalSend = styled.div<{isDisabled?: boolean}>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: #909090;
  // color: ${Colors.galBlack10};
  column-gap: 0px;
  display: flex;
  align-items: center;
  //cursor: pointer;
  width: fit-content;
  white-space: nowrap;
  opacity: ${({isDisabled}) => isDisabled ? 0.5 : 1};
  cursor: ${({isDisabled}) => isDisabled ? 'auto' : 'pointer'};

  @media(max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
    width: 100%;
  }

  &:hover {
    .send-word {
      color: #151514;
    }

    svg path {
      fill: #151514;
    }
  }
`

export const ShareModalUrlField = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 44px;
  width: 341px;

  span {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    width: 90%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ShareModalUrlButton = styled(RectangularButtonFilled)<{isGameDeziiign?: boolean}>`
  height: 44px !important;
  width: 151px !important;
  min-width: 151px !important;
  max-width: 151px !important;
  ${({isGameDeziiign}) => isGameDeziiign && css`
    color: ${Colors.geoWhite100};
    background: ${Colors.galBlack100};
  `}
  
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% - 20px) !important;
    min-width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    height: 38px !important;
    margin: 0px 10px;
    
    span {
      margin-left: 8px;
    }
  }
  
  svg {
    path {
      fill: ${({theme}) => theme.navigationBar.btns.filled.text.main};
      stroke: ${({theme}) => theme.navigationBar.btns.filled.text.main};

      ${p => p.importantStyles ? css`
        fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
        stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.main};
    ` : null}

      &:hover {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
      }
      
      &:active {
        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    &:disabled {
        fill: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};

        ${p => p.importantStyles ? css`
          fill: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
          stroke: ${({theme}) => theme.navigationBar.btns.filled.importantStyles.text};
    ` : null}
    }
    }
  }
`

export const SubmitModalShareButton = styled(RectangularButtonFilled)`
  min-width: unset!important;
  max-width: unset!important;
  width: auto!important;
  padding: 12px 48px;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  height: 46px!important;
  letter-spacing: -0.02em;
  
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 13px;
    line-height: 16px;
    padding: 8px 24px;
    height: 32px!important;
  }
`

export const PrintPDFButton = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  color: ${Colors.galBlack47};

  cursor: pointer;

  display: flex;
  gap: 8px;

  svg {
    position: relative;
    top: -5px;
  }

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    justify-content: center;
  }

  &:hover {
    color: #151514;

    svg path {
      fill: #151514;
    }
  }
`